import { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';

const formatSecondsToTime = (totalSeconds: number): string | number => {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds - hours * 3600) / 60);
    let seconds = totalSeconds - hours * 3600 - minutes * 60;

    // round seconds
    seconds = Math.round(seconds * 100) / 100;

    let result = hours < 10 ? '0' + hours : hours;
    result += ':' + (minutes < 10 ? '0' + minutes : minutes);
    result += ':' + (seconds < 10 ? '0' + seconds : seconds);
    return result;
};

type TimerProps = {
    isReconnecting?: boolean;
};

export const Timer = ({ isReconnecting = false }: TimerProps): string | number => {
    const [time, setTime] = useState<number>(0);
    const { formatMessage } = useIntl();

    useEffect(() => {
        const interval = setInterval(() => {
            setTime((prevTime) => prevTime + 1);
        }, 1000);
        return () => clearInterval(interval);
    }, []);

    return isReconnecting
        ? formatMessage({ id: 'phoning.reconnecting' })
        : formatSecondsToTime(time);
};
